var dependency_type_DependencyType = /*#__PURE__*/ function(DependencyType) {
    DependencyType["Dependency"] = "dependency";
    DependencyType["Dev"] = "devDependency";
    DependencyType["Optional"] = "optionalDependency";
    DependencyType["Peer"] = "peerDependency";
    return DependencyType;
}({});
export { dependency_type_DependencyType as DependencyType };
